module.exports = __webpack_public_path__ + "media/type2(epic).34367a0a.mp4";